
import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { SubmitSchoolDetails } from "../../../../features/admin/Driving_school_details/slice";
import { GetVendorFullDetails } from "../../../../features/admin/common/Slice";
import { useForm } from "react-hook-form";

function Driving_School_Details({ nextStep, prevStep, userId }) {
  const dispatch = useDispatch();

  const vendorData = useSelector((state) => state.common.all_vendor_details);
  console.log("Vendor Data in Driving School Details:", vendorData.school_details);

  // React Hook Form
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  // Fetch vendor full details
  useEffect(() => {
    if (userId) {
      dispatch(GetVendorFullDetails(userId));
    }
  }, [userId, dispatch]);

  // Autofill when Redux data comes
  useEffect(() => {
    if (vendorData?.school_details) {
      const sd = vendorData.school_details;
      const rc = vendorData.vendor;

      setValue("school_name", sd.school_name || "");
      setValue("rto", sd.RTO || "");
      // setValue("vendor_code", rc.referral_code || "");
      setValue("gst_no", sd.GST_no || "");
    }
  }, [vendorData, setValue]);

  // Submit
  const onSubmit = async (data) => {
    const payload = {
      user_id: userId,
      school_name: data.school_name,
      rto: data.rto,
      // vendor_code: data.vendor_code,
      gst_no: data.gst_no,
    };

    const res = await dispatch(SubmitSchoolDetails(payload));

    if (res?.payload?.success) {
      nextStep();
    }
  };

  return (
    <div className="stepform_form">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <div className="row">

            {/* Driving School Name */}
            <div className="col-12 mt-3">
              <div className="form-group__element">
                <Form.Control
                  type="text"
                  placeholder="Name of your Driving School"
                  className="form-group__input"
                  {...register("school_name", { required: "School Name is Required" })}
                />
                {errors.school_name && (
                  <small className="text-danger">{errors.school_name.message}</small>
                )}
              </div>
            </div>

            {/* RTO */}
            <div className="col-12 mt-3">
              <div className="form-group__element">
                <Form.Control
                  type="text"
                  placeholder="Your RTO (e.g., KL01, Trivandrum)"
                  className="form-group__input"
                  {...register("rto", { required: " RTO Number isRequired" })}
                />
                <Form.Text className="text-muted">(KL01, Trivandrum)</Form.Text>
                {errors.rto && (
                  <small className="text-danger">{errors.rto.message}</small>
                )}
              </div>
            </div>

            {/* Vendor Code (hidden field, earlier removed) */}
            <input type="hidden" {...register("vendor_code")} />

            {/* GST No */}
          <div className="col-12 mt-3">
  <div className="form-group__element">
    <Form.Control
      type="text"
      placeholder="GST No."
      className="form-group__input"
      {...register("gst_no", {
        // required: "GST number is required",
        pattern: {
          value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
          message: "Enter a valid GST number",
        },
      })}
    />
    {errors.gst_no && (
      <small className="text-danger">{errors.gst_no.message}</small>
    )}
  </div>
</div>


          </div>
        </div>

        {/* Buttons */}
        <div className="buttons">
          <Button className="back_btn form_btn mt-4" onClick={prevStep}>
            Back
          </Button>
          <Button className="search_btn form_btn mt-4" type="submit">
            Save and Next
          </Button>
        </div>
      </form>
    </div>
  );
}

export default Driving_School_Details;




















// import React, { useState, useEffect } from "react";
// import { Button, Form } from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
// import { SubmitSchoolDetails } from "../../../../features/admin/Driving_school_details/slice";
// import { GetVendorFullDetails } from "../../../../features/admin/common/Slice";

// function Driving_School_Details({ nextStep, prevStep, userId }) {
//   const dispatch = useDispatch();

//   // Redux me jo API ka data save hua hai wo yaha milega
//   const vendorData = useSelector((state) => state.common.all_vendor_details);

//   console.log("Vendor Data in Driving School Details:", vendorData.school_details);

//   // Local states
//   const [schoolName, setSchoolName] = useState("");
//   const [rto, setRto] = useState("");
//   const [vendorCode, setVendorCode] = useState("");
//   const [gstNo, setGstNo] = useState("");

//   // Fetch vendor full details when userId available
//   useEffect(() => {
//     if (userId) {
//       dispatch(GetVendorFullDetails(userId));
//     }
//   }, [userId, dispatch]);

//   // Autofill when Redux data updates
//   useEffect(() => {
//     if (vendorData?.school_details) {
//       const sd = vendorData.school_details;
//       const rc=vendorData.vendor;

//       console.log("School Details:", sd);

//       setSchoolName(sd.school_name || "");
//       setRto(sd.RTO || "");
//       setVendorCode(rc.referral_code || "");
//       setGstNo(sd.GST_no || "");
//     }
//   }, [vendorData]);

//   // Submit handler
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const payload = {
//       user_id: userId,
//       school_name: schoolName,
//       rto: rto,
//       vendor_code: vendorCode,
//       gst_no: gstNo,
//     };

//     const res = await dispatch(SubmitSchoolDetails(payload));

//     if (res?.payload?.success) {
//       nextStep();
//     }
//   };

//   return (
//     <div className="stepform_form">
//       <form onSubmit={handleSubmit}>
//         <div className="form-group">
//           <div className="row">

//             {/* Driving School Name */}
//             <div className="col-12 mt-3">
//               <div className="form-group__element">
//                 <Form.Control
//                   type="text"
//                   placeholder="Name of your Driving School"
//                   className="form-group__input"
//                   value={schoolName}
//                   onChange={(e) => setSchoolName(e.target.value)}
//                   required
//                 />
//               </div>
//             </div>

//             {/* RTO */}
//             <div className="col-12 mt-3">
//               <div className="form-group__element">
//                 <Form.Control
//                   type="text"
//                   placeholder="Your RTO (e.g., KL01, Trivandrum)"
//                   className="form-group__input"
//                   value={rto}
//                   onChange={(e) => setRto(e.target.value)}
//                   required
//                 />
//                 <Form.Text className="text-muted">(KL01, Trivandrum)</Form.Text>
//               </div>
//             </div>

//             {/* Vendor Code */}
//             {/* <div className="col-12 mt-3">
//               <div className="form-group__element">
//                 <Form.Control
//                   type="text"
//                   placeholder="Vendor Code"
//                   className="form-group__input"
//                   value={vendorCode}
//                   onChange={(e) => setVendorCode(e.target.value)}
//                   required
//                 />
//               </div>
//             </div> */}

//             {/* GST No */}
//             <div className="col-12 mt-3">
//               <div className="form-group__element">
//                 <Form.Control
//                   type="text"
//                   placeholder="GST No."
//                   className="form-group__input"
//                   value={gstNo}
//                   onChange={(e) => setGstNo(e.target.value)}
//                    required
//                 />
//               </div>
//             </div>

//           </div>
//         </div>

//         {/* Buttons */}
//         <div className="buttons">
//           <Button className="back_btn form_btn mt-4" onClick={prevStep}>
//             Back
//           </Button>
//           <Button className="search_btn form_btn mt-4" type="submit">
//             Save and Next
//           </Button>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default Driving_School_Details;




























// import React from "react";
// import { Stepper } from "react-form-stepper";
// import { Button, Form } from "react-bootstrap";

// function Driving_School_Details({ nextStep, prevStep }) {
//   return (
//     <>
      
//       <div className="stepform_form">
//         <form>
         

//           <div className="form-group">
//             <div className="row">
//               {/* Driving School Name */}
//               <div className="col-12 mt-3">
//                 <div className="form-group__element">
//                   <Form.Control
//                     type="text"
//                     placeholder="Name of your Driving School"
//                     className="form-group__input"
//                   />
//                 </div>
//               </div>

//               {/* RTO */}
//               <div className="col-12 mt-3">
//                 <div className="form-group__element">
//                   <Form.Control
//                     type="text"
//                     placeholder="Your RTO (e.g., KL01, Trivandrum)"
//                     className="form-group__input"
//                   />
//                   <Form.Text className="text-muted">(KL01, Trivandrum)</Form.Text>
//                 </div>
//               </div>

//               {/* Vendor Code */}
//               <div className="col-12 mt-3">
//                 <div className="form-group__element">
//                   <Form.Control
//                     type="text"
//                     placeholder="Vendor Code"
//                     className="form-group__input"
//                   />
//                 </div>
//               </div>

//               {/* GST No */}
//               <div className="col-12 mt-3">
//                 <div className="form-group__element">
//                   <Form.Control
//                     type="text"
//                     placeholder="GST No."
//                     className="form-group__input"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className="buttons">
//             <Button className="back_btn form_btn mt-4" onClick={prevStep}>
//               Back
//             </Button>
//             <Button className="search_btn form_btn mt-4" onClick={nextStep}>
//               Save and Next
//             </Button>

//           </div>
//         </form>
//       </div>
//     </>
//   );
// }

// export default Driving_School_Details;





